module.exports = __webpack_public_path__ + "img/b1a.91cfe2dd.jpg";